import { render, staticRenderFns } from "./FrkNav.vue?vue&type=template&id=a067e5a4&"
import script from "./FrkNav.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FrkNav.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports